module.exports = __webpack_public_path__ + "img/img_ serve1.fb273b71.png";